module.exports = __webpack_public_path__ + "assets/img/swiper-3-3.583e7049.jpg";